import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditTimerType = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Editing Timer Type'
      fields={fields}
      apiPath={`admin/timer_types/${props.params.timerTypeId}`}
      successRedirectPath='/write-now/timer_types'
      buildMenuItems={menuItems}
    />
  )
}

export default EditTimerType
